import React from 'react'
import { Button } from 'react-bootstrap'
import { useCart } from '../contexts/CartContext'

const ProductAddToCart = ({ product, t }) => {
  const isShopEnabled = process.env.REACT_APP_TOGGLE_SHOP === 'true'
  const { addProductToCart } = useCart()

  const handleAddToCart = () => {
    addProductToCart(product)
  }

  if (!isShopEnabled || product.name === "STANDARD_PHOTO") return null

  return (
    <Button variant="primary" size="sm" onClick={handleAddToCart} style={{marginLeft:"10px"}}>
      {t('ADD_TO_CART')}
    </Button>
  )
}

export default ProductAddToCart
